import RootError from "@/components/errors/route-error";
import { createRootRoute, Outlet } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: RootError,
});

function RootLayout() {
  return (
    <>
      <div className="antialiased">
        <Outlet />
      </div>
    </>
  );
}
